module.exports = __webpack_public_path__ + "img/icon-chevron-right-green-alt.b765edc3.svg";